// Shared post-login routing for the admin app. Used by the login form and the
// portal chooser so a user lands in the right place for their active role.

export const ADMIN_ROLES = new Set([
  "Master Admin",
  "Admin",
  "Manager",
  "Employee",
]);

export const MODULE_TO_ROUTE: Record<string, string> = {
  dashboard: "/dashboard",
  roles: "/roles",
  modules: "/modules",
  users: "/hr/users",
  "users-permissions": "/hr/permissions",
  products: "/products",
  suppliers: "/suppliers",
  customers: "/customers",
  leads: "/leads",
  "tour-types": "/tour/tour-types",
  "tour-packages": "/tour/tour-packages",
  bookings: "/bookings",
  countries: "/locations/countries",
  regions: "/locations/regions",
  cities: "/locations/cities",
  currencies: "/currencies",
  airlines: "/flights/airlines",
  airports: "/flights/airports",
};

/** Resolve where to send a user immediately after a session is established. */
export function resolvePostLoginRoute(user: any): string {
  const roleName = String(user?.roleName ?? "").trim();
  const modules: string[] = Array.isArray(user?.modules)
    ? user.modules.map((m: unknown) => String(m ?? ""))
    : [];
  const norm = (v: unknown) => String(v ?? "").trim().toLowerCase();
  const moduleSet: Set<string> = new Set(modules.map(norm));

  if (ADMIN_ROLES.has(roleName)) {
    return "/dashboard";
  }

  if (roleName === "Supplier") {
    const priority = [
      "tour-packages",
      "products",
      "leads",
      "bookings",
      "suppliers",
    ];
    for (const slug of priority) {
      if (moduleSet.has(slug) && MODULE_TO_ROUTE[slug]) {
        return MODULE_TO_ROUTE[slug];
      }
    }

    for (const slug of Array.from(moduleSet)) {
      if (MODULE_TO_ROUTE[slug]) {
        return MODULE_TO_ROUTE[slug];
      }
    }
  }

  return "/account";
}
